(function () {
    'use strict';

    angular
        .module('elogbooks.admin.site-associations')
        .config(registerRoutes)
        .config(registerRoutesList)
        .config(registerRoutesDetails);

    function registerRoutes ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.site-associations', {
                abstract: true,
                templateUrl: 'shared-templates/view.html',
                ncyBreadcrumb: {
                    skip: true
                },
                data: {
                    permissions: ['user_permission_manage_user_site_associations', 'user_permission_view_users']
                }
            });
    }

    function registerRoutesList ($stateProvider) {
        $stateProvider
            .state('dashboard.admin.site-associations.list', {
                url: '/site-associations?page&limit&order&adminUserId&userName&userCategory&userUsername&userEmail&userServiceProviderName$userStatus',
                parent: 'dashboard.admin.site-associations',
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations': {
                        templateUrl: '/modules/admin/site-associations/user-list.html',
                        controller: 'UsersController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: '1',
                    limit: '30',
                    order: 'id',

                    adminUserId: null,
                    userName: null,
                    userCategory: {array: true},
                    userUsername: null,
                    userEmail: null,
                    userServiceProviderName: null,
                    userStatus: null,
                    userId: null,
                    excludeUserSites: null,
                    membershipPermissionAny: {array: true}
                },
                resolve: {
                    userCollectionResponse: function ($stateParams, apiClient, rootResourceResponse) {
                        var params = {
                            page: $stateParams.page,
                            limit: $stateParams.limit,
                            order: $stateParams.order,
                            id: $stateParams.adminUserId,
                            name: $stateParams.userName,
                            'category[]': $stateParams.userCategory,
                            username: $stateParams.userUsername,
                            email: $stateParams.userEmail,
                            serviceProviderName: $stateParams.userServiceProviderName,
                            status: $stateParams.userStatus,
                            'membershipPermissionAny[]': [
                                'site_permission_can_be_associate',
                                'site_permission_can_be_approver'
                            ],
                        };

                        return apiClient.get(rootResourceResponse.getLink('users'), params).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    userTypesResponse: function (apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('usertypes')).then(function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    userCategoriesResponse: function (apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('usercategories')).then(function(response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"SITE_ASSOCIATIONS" | translate }}'
                }
            });
    }

    function registerRoutesDetails($stateProvider) {
        $stateProvider
            .state('dashboard.admin.site-associations.list.details', {
                url: '/details/{resource}',
                abstract: true,
                parent: 'dashboard.admin.site-associations.list',
                params: {
                    addAssociates: []
                },
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations': {
                        templateUrl: '/modules/admin/site-associations/details/_wrapper.html',
                        controller: 'SiteAssociateDetailsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    userResponse: function (apiClient, $stateParams) {
                        return apiClient.get($stateParams.resource.decode()).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::$resolves().userResponse.name }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.user', {
                url: '/user',
                parent: 'dashboard.admin.site-associations.list.details',
                params: {
                    addAssociates: []
                },
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                        templateUrl: '/modules/admin/site-associations/details/user/user.html',
                        controller: 'SiteAssociateUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    userResponse: function (userResponse) {
                        return userResponse;
                    },
                    siteAssociateAccessResponse: function (userResponse, $state, $stateParams, $q) {
                        return guardSiteAssociateAccess(userResponse, $state, $stateParams, $q);
                    },
                    siteCollectionResponse: function(userResponse, rootResourceResponse, apiClient) {
                        return apiClient.get(rootResourceResponse.getLink('sites'), {
                            withAccess: userResponse.id,
                            status: 'active'
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        })
                    },
                    siteAssociateCollectionResponse: function(userResponse, apiClient) {
                        return apiClient.get(userResponse.getLink('user-site-associates')).then(function (response) {
                            return response || apiClient.noResourceFound();
                        })
                    },
                    siteAssociateTypeCollectionResponse: function (apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('siteassociatetypes')).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"ASSOCIATE_TYPES" | translate }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.reassign', {
                url: '/reassign?siteIds&regionIds&siteGroup&coreClient&siteStatus',
                parent: 'dashboard.admin.site-associations.list.details',
                params: {
                    addAssociates: [],
                    siteIds: {array: true},
                    regionIds: {array: true},
                    siteGroup: null,
                    coreClient: null,
                    siteStatus: null
                },
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                        templateUrl: '/modules/admin/site-associations/details/reassign/reassign.html',
                        controller: 'SiteAssociateReassignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    userResponse: function (userResponse) {
                        return userResponse;
                    },
                    siteAssociateAccessResponse: function (userResponse, $state, $stateParams, $q) {
                        return guardSiteAssociateAccess(userResponse, $state, $stateParams, $q);
                    },
                    associatesUsersResponse: function (userResponse, apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('users'), {
                            membershipPermission: ['site_permission_can_be_associate'],
                            status: 'active',
                            'excludeUserIds[]': userResponse.id,
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    siteAssociateCollectionResponse: function(userResponse, apiClient, $stateParams) {
                        return apiClient.get(
                            userResponse.getLink('user-site-associates'),
                            getSiteReassignFilterParams($stateParams)
                        ).then(function (response) {
                            return response || apiClient.noResourceFound();
                        })
                    },
                    siteGroupCollectionResponse: function (apiClient, rootResourceResponse) {
                        var link = rootResourceResponse.getLink('sitegroups');

                        if (!link) {
                            return null;
                        }

                        return apiClient.get(link, {
                            active: 'yes',
                            order: 'name'
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    coreClientCollectionResponse: function (apiClient, rootResourceResponse) {
                        var link = rootResourceResponse.getLink('coreclients');

                        if (!link) {
                            return null;
                        }

                        return apiClient.get(link, {
                            active: 'yes',
                            order: 'name'
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"ASSOCIATE_REASSIGN" | translate }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.approver', {
                url: '/approver',
                parent: 'dashboard.admin.site-associations.list.details',
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                        templateUrl: '/modules/admin/site-associations/details/approver/approver.html',
                        controller: 'SiteApproverUserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    siteCollectionLink: function(rootResourceResponse) {
                        return rootResourceResponse.getLink('sites');
                    },
                    siteApproverAccessResponse: function (userResponse, $state, $stateParams, $q) {
                        return guardSiteApproverAccess(userResponse, $state, $stateParams, $q);
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"APPROVAL_TYPES" | translate }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.approvals-reassign', {
                url: '/approvals-reassign?siteIds&regionIds&siteGroup&coreClient&siteStatus',
                parent: 'dashboard.admin.site-associations.list.details',
                params: {
                    siteIds: {array: true},
                    regionIds: {array: true},
                    siteGroup: null,
                    coreClient: null,
                    siteStatus: null
                },
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                        templateUrl: '/modules/admin/site-associations/details/approvals-reassign/approvals-reassign.html',
                        controller: 'SiteApprovalsReassignController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    siteApproverAccessResponse: function (userResponse, $state, $stateParams, $q) {
                        return guardSiteApproverAccess(userResponse, $state, $stateParams, $q);
                    },
                    siteApproverTypeCollectionResponse: function (userResponse, apiClient, $stateParams) {
                        return apiClient.get(
                            userResponse.getLink('user-site-approver-types'),
                            getSiteReassignFilterParams($stateParams)
                        ).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    approverUsersResponse: function (userResponse, apiClient, rootResourceResponse) {
                        return apiClient.get(rootResourceResponse.getLink('users'), {
                            membershipPermission: ['site_permission_can_be_approver'],
                            status: 'active',
                            'excludeUserIds[]': userResponse.id
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    siteGroupCollectionResponse: function (apiClient, rootResourceResponse) {
                        var link = rootResourceResponse.getLink('sitegroups');

                        if (!link) {
                            return null;
                        }

                        return apiClient.get(link, {
                            active: 'yes',
                            order: 'name'
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                    coreClientCollectionResponse: function (apiClient, rootResourceResponse) {
                        var link = rootResourceResponse.getLink('coreclients');

                        if (!link) {
                            return null;
                        }

                        return apiClient.get(link, {
                            active: 'yes',
                            order: 'name'
                        }).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"APPROVALS_REASSIGN" | translate }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.audit-trail', {
                url: '/audit-trail?siteAssociationAuditTrailPage&siteAssociationAuditTrailLimit',
                parent: 'dashboard.admin.site-associations.list.details',
                params: {
                    siteAssociationAuditTrailPage: '1',
                    siteAssociationAuditTrailLimit: '30'
                },
                data: {
                    permissions: ['user_permission_view_users']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                        templateUrl: '/modules/admin/site-associations/details/audit-trail/audit-trail.html',
                        controller: 'SiteAssociationsAuditTrailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    eventCollectionResponse: function (apiClient, $stateParams, userResponse) {
                        if (userResponse.getLink('site-association-events')) {
                            return apiClient.get(userResponse.getLink('site-association-events'), {
                                datagroup: 'details',
                                page: $stateParams.siteAssociationAuditTrailPage || 1,
                                limit: $stateParams.siteAssociationAuditTrailLimit || 30
                            }).then(function(response) {
                                return response || apiClient.noResourceFound();
                            });
                        }
                    }
                },
                ncyBreadcrumb: {
                    label: '{{ ::"AUDIT_TRAIL" | translate }}'
                }
            })
            .state('dashboard.admin.site-associations.list.details.user.add', {
                url: '/add',
                parent: 'dashboard.admin.site-associations.list.details.user',
                data: {
                    permissions: ['user_permission_manage_user_site_associations']
                },
                views: {
                    '@dashboard.admin.site-associations.list.details': {
                    templateUrl: '/modules/admin/site-associations/add/associate-types-add.html',
                        controller: 'AssociateTypesAddController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    siteAssociateAccessResponse: function (userResponse, $state, $stateParams, $q) {
                        return guardSiteAssociateAccess(userResponse, $state, $stateParams, $q);
                    },
                    siteAssociateTypeCollectionExcludeExistingResponse: function ($stateParams, apiClient, rootResourceResponse, siteAssociateCollectionResponse) {
                        const excludeTypes = (() => {
                            // currently associated with the user
                            const existingTypeIds = siteAssociateCollectionResponse.siteAssociateTypes
                                .filter(associate => associate)
                                .map(associate => associate.id);

                            // Filter out types that are already in addAssociates but not in the removed list
                            const excludedTypesFromAddAssociates = ($stateParams.addAssociates || [])
                                .filter(associate =>
                                    associate && !associate.removed)
                                .map(associate => associate.id);

                            return [...new Set([...excludedTypesFromAddAssociates, ...existingTypeIds])];
                        })();

                        return apiClient.get(rootResourceResponse.getLink('siteassociatetypes'), {'excludedTypes[]': excludeTypes}).then(function (response) {
                            return response || apiClient.noResourceFound();
                        });
                    },
                },
                ncyBreadcrumb: {
                    label: '{{ ::"ADD" | translate }}'
                }
            });
    }

    function getSiteReassignFilterParams($stateParams) {
        var params = {};

        if ($stateParams.siteIds && $stateParams.siteIds.length) {
            params['siteIds[]'] = $stateParams.siteIds;
        }

        if ($stateParams.regionIds && $stateParams.regionIds.length) {
            params['regionIds[]'] = $stateParams.regionIds;
        }

        if ($stateParams.siteGroup) {
            params.siteGroup = JSON.parse($stateParams.siteGroup).v;
        }

        if ($stateParams.coreClient) {
            params.coreClient = JSON.parse($stateParams.coreClient).v;
        }

        if ($stateParams.siteStatus) {
            params.siteStatus = $stateParams.siteStatus;
        }

        return params;
    }

    function guardSiteAssociateAccess(userResponse, $state, $stateParams, $q) {
        if (userResponse.canBeSiteAssociate) {
            return true;
        }

        $state.go(
            userResponse.canBeSiteApprover
                ? 'dashboard.admin.site-associations.list.details.approver'
                : 'dashboard.admin.site-associations.list',
            userResponse.canBeSiteApprover ? { resource: $stateParams.resource } : {},
            { location: 'replace' }
        );

        return $q.reject('USER_DOES_NOT_HAVE_PERMISSION_TO_BE_SITE_ASSOCIATE');
    }

    function guardSiteApproverAccess(userResponse, $state, $stateParams, $q) {
        if (userResponse.canBeSiteApprover) {
            return true;
        }

        $state.go(
            userResponse.canBeSiteAssociate
                ? 'dashboard.admin.site-associations.list.details.user'
                : 'dashboard.admin.site-associations.list',
            userResponse.canBeSiteAssociate ? { resource: $stateParams.resource } : {},
            { location: 'replace' }
        );

        return $q.reject('USER_DOES_NOT_HAVE_PERMISSION_TO_BE_SITE_APPROVER');
    }
})();
